/**
 * FX3 C12 — on a 390px screen the data tables pushed the most important columns
 * (Amount, Credit Limit, Status, Actions) off-screen with no scroll affordance
 * (UI issues 16, 17, 18). MobileCards renders the same rows as stacked cards
 * below 768px; the table stays exactly as it is from md: upwards.
 */
export const MobileCardList = ({ children, testid }) => (
  <div className="md:hidden space-y-2" data-testid={testid}>{children}</div>
);

export const MobileCard = ({ title, subtitle, amount, rows = [], actions, testid, badge }) => (
  <div className="border border-zinc-200 rounded-sm bg-white p-3" data-testid={testid}>
    <div className="flex items-start justify-between gap-3">
      <div className="min-w-0">
        <p className="font-mono text-xs font-semibold text-zinc-900 truncate">{title}</p>
        {subtitle ? <p className="text-xs text-zinc-600 mt-0.5 truncate">{subtitle}</p> : null}
      </div>
      <div className="text-right shrink-0">
        {amount !== undefined && amount !== null ? (
          <p className="font-mono text-sm font-semibold text-zinc-900" data-testid={testid ? `${testid}-amount` : undefined}>{amount}</p>
        ) : null}
        {badge}
      </div>
    </div>
    {rows.length > 0 && (
      <dl className="mt-2 grid grid-cols-2 gap-x-3 gap-y-1 border-t border-zinc-100 pt-2">
        {rows.filter(r => r).map((r, i) => (
          <div key={i} className="min-w-0">
            <dt className="text-[9px] uppercase tracking-wider text-zinc-400">{r.label}</dt>
            <dd className="text-[11px] text-zinc-700 truncate">{r.value || "—"}</dd>
          </div>
        ))}
      </dl>
    )}
    {actions ? <div className="mt-2 flex items-center gap-1 border-t border-zinc-100 pt-2">{actions}</div> : null}
  </div>
);
